import axios from "./axiosConfig";

const eventsService = {
  /**
   * Obtener todos los eventos con filtros opcionales
   * @param {Object} filters - Filtros opcionales (startDate, endDate, eventType, status, technician, client, branch, priority)
   */
  getAll(filters = {}) {
    return axios.get("/events", { params: filters });
  },

  /**
   * Obtener un evento por ID
   * @param {string} id - ID del evento
   */
  getById(id) {
    return axios.get(`/events/${id}`);
  },

  /**
   * Crear un nuevo evento
   * @param {Object} data - Datos del evento
   */
  create(data) {
    return axios.post("/events", data);
  },

  /**
   * Actualizar un evento existente
   * @param {string} id - ID del evento
   * @param {Object} data - Datos a actualizar
   */
  update(id, data) {
    return axios.put(`/events/${id}`, data);
  },

  /**
   * Eliminar un evento
   * @param {string} id - ID del evento
   */
  delete(id) {
    return axios.delete(`/events/${id}`);
  },

  /**
   * Obtener eventos por mes y año
   * @param {number} year - Año
   * @param {number} month - Mes (1-12)
   */
  getByMonth(year, month) {
    return axios.get(`/events/calendar/${year}/${month}`);
  },

  /**
   * Obtener eventos por rango de fechas
   * @param {string} startDate - Fecha de inicio (ISO)
   * @param {string} endDate - Fecha de fin (ISO)
   */
  getByDateRange(startDate, endDate) {
    return axios.get("/events/date-range", {
      params: { startDate, endDate }
    });
  },

  /**
   * Obtener eventos de un técnico específico
   * @param {string} technicianId - ID del técnico
   * @param {Object} filters - Filtros opcionales (startDate, endDate, status)
   */
  getByTechnician(technicianId, filters = {}) {
    return axios.get(`/events/technician/${technicianId}`, { params: filters });
  },

  /**
   * Obtener estadísticas de eventos
   * @param {Object} filters - Filtros opcionales (startDate, endDate)
   */
  getStats(filters = {}) {
    return axios.get("/events/stats", { params: filters });
  },

  getRecurrenceOverview(params = {}) {
    return axios.get("/events/recurrence/overview", { params });
  },

  syncRecurrence(payload = {}) {
    return axios.post("/events/recurrence/sync", payload);
  },
};

export default eventsService;